import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

/**
 * interfaces
 */
import { IResponse } from '@network';
import { IFacilityDto, IUpdateFacilityPayload } from '../../interfaces';

/**
 * constants
 */
import { FacilityConst } from '../../consts';

/**
 * HTTP layer for the Facility sub-module.
 * Responsible only for making raw HTTP requests and returning typed IResponse wrappers.
 * Business logic and response mapping belong in FacilityService.
 */
@Injectable()
export class FacilityApiService {

    /**
     * @param _http Angular HTTP client.
     */
    constructor(private readonly _http: HttpClient) {}

    /**
     * Retrieves the facility details from the API.
     * @returns Observable wrapping the full facility DTO.
     */
    public getFacility(): Observable<IResponse<IFacilityDto>> {
        return this._http.get<IResponse<IFacilityDto>>(FacilityConst.GET_FACILITY_ENDPOINT);
    }

    /**
     * Updates the facility with the given payload.
     * @param id - The UUID of the facility to update.
     * @param payload - The update payload matching IUpdateFacilityPayload.
     * @returns Observable wrapping the success message string.
     */
    public updateFacility(id: string, payload: IUpdateFacilityPayload): Observable<IResponse<string>> {
        return this._http.put<IResponse<string>>(FacilityConst.UPDATE_FACILITY_ENDPOINT(id), payload);
    }


}
